import { render } from "./AboutOscarPoolsPage.vue?vue&type=template&id=1adae681&scoped=true"
import script from "./AboutOscarPoolsPage.vue?vue&type=script&lang=js"
export * from "./AboutOscarPoolsPage.vue?vue&type=script&lang=js"

import "./AboutOscarPoolsPage.vue?vue&type=style&index=0&id=1adae681&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adae681"]])

export default __exports__